import { User } from 'redux/schemas/models/my-account';
import { MentoringProgram } from 'redux/schemas/models/mentoring-programs';

export type TargetConfig = {
  name: string;
  releasedDate: string | null;
  description: string;
};

export type CloneAdmin = {
  id: number;
  user: Pick<User, 'id' | 'firstName' | 'lastName' | 'fullName' | 'initials' | 'profilePicture' | 'email'> & Partial<User>;
};

export type CloneMentorshipProgramState = {
  cloneProgress: any;
  sourceProgram: MentoringProgram | null;
  targetConfig: TargetConfig;
  admins: CloneAdmin[];
  selectedAdmins: Record<string, boolean>;
  isFetchingAdmins: boolean;
  step: number;
  isCloning: boolean;
  errors: Record<string, string>;
};

export enum CloneMentorshipProgramActionType {
  SET_SOURCE_PROGRAM = 'SET_SOURCE_PROGRAM',
  UPDATE_TARGET_CONFIG = 'UPDATE_TARGET_CONFIG',
  TOGGLE_ADMIN = 'TOGGLE_ADMIN',
  TOGGLE_ALL_ADMINS = 'TOGGLE_ALL_ADMINS',
  SET_ADMINS = 'SET_ADMINS',
  SET_FETCHING_ADMINS = 'SET_FETCHING_ADMINS',
  SET_STEP = 'SET_STEP',
  NEXT_STEP = 'NEXT_STEP',
  PREV_STEP = 'PREV_STEP',
  SET_CLONING_STATUS = 'SET_CLONING_STATUS',
  SET_ERRORS = 'SET_ERRORS',
  RESET_WIZARD = 'RESET_WIZARD',
  ADD_CLONE_PROGRESS = 'ADD_CLONE_PROGRESS',
  UPDATE_CLONE_PROGRESS = 'UPDATE_CLONE_PROGRESS',
}

export enum CloneMentorshipProgramWizardStep {
  CONFIG = 1,
  ADMIN_REVIEW = 2,
  REVIEW = 3,
}

export type CloneMentorshipProgramAction =
  | { type: CloneMentorshipProgramActionType.SET_SOURCE_PROGRAM; payload: MentoringProgram }
  | { type: CloneMentorshipProgramActionType.UPDATE_TARGET_CONFIG; payload: Partial<TargetConfig> }
  | { type: CloneMentorshipProgramActionType.TOGGLE_ADMIN; payload: { adminId: string; selected: boolean } }
  | { type: CloneMentorshipProgramActionType.TOGGLE_ALL_ADMINS; payload: { selected: boolean } }
  | { type: CloneMentorshipProgramActionType.SET_ADMINS; payload: CloneAdmin[] }
  | { type: CloneMentorshipProgramActionType.SET_FETCHING_ADMINS; payload: boolean }
  | { type: CloneMentorshipProgramActionType.SET_STEP; payload: CloneMentorshipProgramWizardStep }
  | { type: CloneMentorshipProgramActionType.NEXT_STEP }
  | { type: CloneMentorshipProgramActionType.PREV_STEP }
  | { type: CloneMentorshipProgramActionType.SET_CLONING_STATUS; payload: boolean }
  | { type: CloneMentorshipProgramActionType.SET_ERRORS; payload: Record<string, string> }
  | { type: CloneMentorshipProgramActionType.RESET_WIZARD };
